<div class="d-block d-lg-none">
  <fgb-page-header
    [pageTitle]="'terms.page.title'"
    [backButtonLink]="'/'"
    [showBalance]="false"
    [showQr]="false"
  ></fgb-page-header>
</div>

<fgb-banner [title]="'terms.page.title' | translate"></fgb-banner>

<div class="container terms-container">
  <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">Loading...</p>
</ng-template>
